<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.ivu-layout .ivu-layout-sider{
  position: fixed;
  left: 0px;
  top: 0px;
  height: 100%;
      z-index: 1001;
    overflow: hidden;
}

.layout-header-bar{
  position: fixed;
  right:0px;
  top:0px;
    width: calc(100% - 200px);
        z-index: 9;
}
</style>



// WEBPACK FOOTER //
// src/App.vue